import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { DEFAULT_API_CONFIG, TENANT_API_ENDPOINT } from '../utils/constants';

const sharedQueryConfig = {
  keepUnusedDataFor: 0, // This will prevent the data from being cached. We want to always fetch the latest data.
};

const TimeoutOverride = 600000; // 10 minutes

export const reportsApi = createApi({
  reducerPath: 'reportsApi',
  baseQuery: fetchBaseQuery({
    baseUrl: DEFAULT_API_CONFIG.baseURL,
    timeout: TimeoutOverride,
    headers: DEFAULT_API_CONFIG.headers,
  }),
  endpoints: (builder) => ({
    getAdminReport: builder.query<IReportData, unknown>({
      query: ({ activeTeams, activeDeselectedCourses }) => {
        return {
          url: `${TENANT_API_ENDPOINT}/admin/reports/general`,
          method: 'POST',
          body: { teamIds: activeTeams, deselectedCourseIds: activeDeselectedCourses },
        };
      },
      ...sharedQueryConfig,
    }),
    getTeamManagerReport: builder.query<IReportData, unknown>({
      query: ({ activeTeams, activeDeselectedCourses }) => ({
        url: `${TENANT_API_ENDPOINT}/reporting/report`,
        method: 'POST',
        body: { teamIds: activeTeams, deselectedCourseIds: activeDeselectedCourses },
      }),
      ...sharedQueryConfig,
    }),
  }),
});

export const { useGetAdminReportQuery, useGetTeamManagerReportQuery } = reportsApi;
